/** Human-readable message from Supabase/PostgREST client errors. */
export function postgrestErrorMessage(err: unknown): string {
  if (err == null) return "Unknown error.";
  if (typeof err === "object" && err !== null && "message" in err) {
    const o = err as { message?: unknown; details?: unknown; hint?: unknown };
    const parts = [
      o.message != null ? String(o.message) : "",
      o.details != null ? String(o.details) : "",
      o.hint != null ? String(o.hint) : "",
    ].filter((s) => s.length > 0);
    if (parts.length > 0) return parts.join(" — ");
  }
  if (err instanceof Error) return err.message;
  return String(err);
}
